var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEarmarkSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8125 14.0625H4.6875V12.5H20.3125V14.0625H15.625V17.1875H20.3125V18.75H15.625V21.875H14.0625V18.75H9.375V21.875H7.8125V18.75H4.6875V17.1875H7.8125V14.0625ZM9.375 14.0625V17.1875H14.0625V14.0625H9.375Z",
    fill: "#004BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 1.5625H14.0625V3.125H6.25C5.8356 3.125 5.43817 3.28962 5.14515 3.58265C4.85212 3.87567 4.6875 4.2731 4.6875 4.6875V20.3125C4.6875 20.7269 4.85212 21.1243 5.14515 21.4174C5.43817 21.7104 5.8356 21.875 6.25 21.875H18.75C19.1644 21.875 19.5618 21.7104 19.8549 21.4174C20.1479 21.1243 20.3125 20.7269 20.3125 20.3125V9.375H21.875V20.3125C21.875 21.1413 21.5458 21.9362 20.9597 22.5222C20.3737 23.1083 19.5788 23.4375 18.75 23.4375H6.25C5.4212 23.4375 4.62634 23.1083 4.04029 22.5222C3.45424 21.9362 3.125 21.1413 3.125 20.3125V4.6875C3.125 3.8587 3.45424 3.06384 4.04029 2.47779C4.62634 1.89174 5.4212 1.5625 6.25 1.5625Z",
    fill: "#004BA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.03125V1.5625L21.875 9.375H16.4062C15.7846 9.375 15.1885 9.12807 14.749 8.68853C14.3094 8.24899 14.0625 7.65285 14.0625 7.03125Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEarmarkSpreadsheet);
export default __webpack_public_path__ + "static/media/FileEarmarkSpreadsheet.ea5abeafb3ab4b37ea317c9cf6358dbb.svg";
export { ForwardRef as ReactComponent };